import { lt } from '@mews/framework';
import { useDialogForm } from '@mews-commander/form';
import { DataTestId } from '@mews-commander/enums';
import { WithCancellationPolicyId } from '../types';
import { UpdateCancellationPolicyFormContent } from './CancellationPolicyFormContent';

export const useUpdateCancellationPolicyDialogForm = ({ cancellationPolicyId }: WithCancellationPolicyId) =>
    useDialogForm({
        submitButtonDataTestId: DataTestId.ServiceCancellationPolicySaveEditButton,
        id: `update-cancellation-policy-${cancellationPolicyId}`,
        title: lt('CancellationPolicyUpdateFormTitle'),
        renderForm: (props) => (
            <UpdateCancellationPolicyFormContent cancellationPolicyId={cancellationPolicyId} {...props} />
        ),
    });
